import type { PropsWithChildren } from 'react';

import styled from 'styled-components'

import { BaseAlert, type IBaseAlertProps } from './BaseAlert'
import { IconMagicSolid } from '@ui/elements/Icon/components'
import { IconComponentStyled } from '@ui/elements/Icon/styles/IconComponentStyled'

export const AIAlert = styled(
  ({ ...props }: PropsWithChildren<IBaseAlertProps>) => (
    <BaseAlert
      icon={<IconMagicSolid aria-label='AI alert icon' block size={20} />}
      {...props}
    />
  )
)`
  background-color: ${(props) => props.theme.colors.alert.ai.background};

  border-color: ${(props) => props.theme.colors.alert.ai.border};

  ${IconComponentStyled} {
    color: ${(props) => props.theme.colors.alert.ai.icon};
  }
`

AIAlert.displayName = 'AIAlert'
